import { assoc, curry, keys, reduce } from "ramda";

// https://github.com/ramda/ramda/wiki/Cookbook#rename-keys-of-an-object
export const renameKeys = curry((keysMap, obj) =>
  reduce(
    (acc, key) => assoc(keysMap[key] || key, obj[key], acc),
    {},
    keys(obj),
  ),
);
